import React, { useMemo, useState } from 'react';
import OrderDetailsStepper from '../../../../../../components/OrderDetailsStepper/OrderDetailsStepper';
import PickUpDeliveryDetails from '../../../../../Admin/OrderDetails/components/AdditionalDetails/PickUp&DeliveryDetails';
import BaseOrderDetails from '../../../../../../components/BaseOrderDetails/BaseOrderDetails';
import PickUpSchedule from '../../AdditionalDetails/PickUpSchedule';
import { ProducerOrderProps } from '../../../producerOrder.interface';
import OrderContractDetails from '../../../../../../components/OrderContractDetails/OrderContractDetails';

const Paid: React.FC<ProducerOrderProps> = (props) => {
	const { selectedOrder, contract } = props;
	const [stepperMargin, setStepperMargin] = useState<number>(0);

	const deliveryIncluded = useMemo(() => {
		return selectedOrder?.deliveryIncluded;
	}, [selectedOrder?.deliveryIncluded]);

	const handleWidthChange = (value: number) => {
		setStepperMargin(value);
	};

	const renderInitialSection = () => {
		return deliveryIncluded ? (
			<PickUpSchedule selectedOrder={selectedOrder} step={5} />
		) : (
			<BaseOrderDetails
				selectedOrder={selectedOrder}
				isOpen={true}
				simpleOrder={selectedOrder?.trucks?.length === 1}
				deliveryIncluded={deliveryIncluded!}
				target={selectedOrder?.target!}
				contract={contract}
			/>
		);
	};

	return (
		<>
			<div style={{ marginBottom: `${stepperMargin}px` }}>
				<OrderDetailsStepper
					current={selectedOrder?.deliveryIncluded ? 5 : 6}
					simpleOrder={selectedOrder?.trucks?.length === 1}
					order={selectedOrder}
					onWidthChange={handleWidthChange}
					isFinalStep={true}
				/>
			</div>

			<div className="px-10 pt-7 pb-3.5">
				{contract ? (
					<OrderContractDetails
						selectedOrder={selectedOrder}
						contract={contract}
						target="producer"
					/>
				) : (
					renderInitialSection()
				)}
			</div>

			{contract ? (
				<div className="px-10 py-3.5">{renderInitialSection()}</div>
			) : null}

			{!deliveryIncluded && (
				<div className="px-10 py-3.5">
					<PickUpDeliveryDetails
						selectedOrder={selectedOrder}
						target={selectedOrder?.target}
						isPickUp={true}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				</div>
			)}

			<div className="px-10 pb-7 pt-3.5">
				{deliveryIncluded ? (
					<BaseOrderDetails
						selectedOrder={selectedOrder}
						isOpen={true}
						simpleOrder={selectedOrder?.trucks?.length === 1}
						deliveryIncluded={deliveryIncluded!}
						target={selectedOrder?.target!}
						contract={contract}
					/>
				) : (
					<PickUpSchedule selectedOrder={selectedOrder} step={5} />
				)}
			</div>
		</>
	);
};

export default Paid;
